import React from "react";
import "./Count.css";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";

interface CountProps {
  label?: string;
  count?: number;
  afterCount?: React.ReactNode;
}

const Count: React.FC<CountProps> = ({ label, count, afterCount }) => {
  const getContent = () => {
    return (
      <div className="w-auto flex-column text-md-start">
        <div className="d-flex align-items-baseline gap-2">
          {count || count === 0 ? <div className="count w-auto h2 lh-1 m-0" style={{ fontFamily: 'JerseyM54' }}>{count}</div> : <LoadingSquare />}
          {afterCount}
        </div>

        {label && <div className="label w-auto text-secondary lh-1 h6">{label}</div>}
      </div>
    );
  };

  return <div className="Count d-flex">{getContent()}</div>;
};

export default Count;
